import { Component, Input } from "@angular/core";

@Component({
  selector: 'reception-status',
  templateUrl: './reception-status.component.html'
})
export class ReceptionStatusComponent {
  @Input()
  status!: string
}